import Vue from "vue";
import Vuex from "vuex";
import Ecash from "@/store/Ecash";
import Fatora from "@/store/Fatora";
import loader from "@/store/loader";
import Mtn from "@/store/Mtn";
import checkPolicy from "@/store/checkPolicy";
import paymentGateways from "@/store/paymentGateways";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { Ecash, Fatora, loader, Mtn, checkPolicy, paymentGateways },
});
